var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, forwardRef, useRef, useCallback } from 'react';
import { Affix, Anchor as ArcoAnchor } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import { IconAdd, IconDown, IconUp, IconMenuUnfold, IconMenuFold, } from '@arco-design/iconbox-react-m4b-next';
import AnchorLink from './link';
import './style/anchor.less';
import { useI18nCopy } from './hooks/useI18nCopy';
export var ErrorLinkListContext = React.createContext([]);
function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
function findNode(dom, selector) {
    var s = isString(selector) && selector[0] === '#' ? "[id='".concat(selector.replace('#', ''), "']") : selector;
    try {
        return dom.querySelector(s);
    }
    catch (e) {
        console.error(e);
        return null;
    }
}
function getContainer(targetContainer) {
    if (isString(targetContainer)) {
        return findNode(document, targetContainer);
    }
    return targetContainer || window;
}
var handleOptionsToLink = function (options) {
    return options.map(function (item) { return (React.createElement(AnchorLink, __assign({ key: item.href }, item), item.children && handleOptionsToLink(item.children))); });
};
var AffixWrapper = function (_a) {
    var affix = _a.affix, children = _a.children, rest = __rest(_a, ["affix", "children"]);
    return (affix ? React.createElement(Affix, __assign({}, rest), children) : React.createElement(React.Fragment, null, children));
};
var Anchor = function (props, ref) {
    var t = useI18nCopy();
    var className = props.className, style = props.style, title = props.title, fold = props.fold, children = props.children, _a = props.showAddBtn, showAddBtn = _a === void 0 ? false : _a, addBtnIcon = props.addBtnIcon, _b = props.addBtnText, addBtnText = _b === void 0 ? t.addNewLabel : _b, footer = props.footer, onAddItem = props.onAddItem, errorLinkList = props.errorLinkList, options = props.options, _c = props.linkLimitCount, linkLimitCount = _c === void 0 ? 10 : _c, fixedIconOffsetRight = props.fixedIconOffsetRight, _d = props.hash, hash = _d === void 0 ? false : _d, _e = props.affix, affix = _e === void 0 ? true : _e, offsetTop = props.offsetTop, offsetBottom = props.offsetBottom, affixStyle = props.affixStyle, propScrollContainer = props.scrollContainer, _f = props.anchorProps, anchorProps = _f === void 0 ? {} : _f, rest = __rest(props, ["className", "style", "title", "fold", "children", "showAddBtn", "addBtnIcon", "addBtnText", "footer", "onAddItem", "errorLinkList", "options", "linkLimitCount", "fixedIconOffsetRight", "hash", "affix", "offsetTop", "offsetBottom", "affixStyle", "scrollContainer", "anchorProps"]);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-anchor");
    var _g = __read(useState(true), 2), topUnFold = _g[0], setTopUnFold = _g[1];
    var _h = __read(useState(true), 2), rightUnFold = _h[0], setRightUnFold = _h[1];
    var optionsLength = options === null || options === void 0 ? void 0 : options.length;
    var initOptionsLength = useRef(options === null || options === void 0 ? void 0 : options.length);
    var getAffixTarget = useCallback(function () {
        return getContainer(propScrollContainer);
    }, [propScrollContainer]);
    var handleTopFold = function () {
        setTopUnFold(!topUnFold);
    };
    var handleRightFold = function () {
        setRightUnFold(!rightUnFold);
    };
    var isFolded = !topUnFold || !rightUnFold;
    var topFoldIcon = (React.createElement("div", { className: cx("".concat(prefixCls, "-top-icon-wrapper"), "".concat(prefixCls, "-icon-wrapper")) }, topUnFold ? (React.createElement(IconUp, { onClick: handleTopFold, className: "".concat(prefixCls, "-top-icon") })) : (React.createElement(IconDown, { onClick: handleTopFold, className: "".concat(prefixCls, "-top-icon") }))));
    var rightFoldIcon = (React.createElement(React.Fragment, null, rightUnFold ? (React.createElement("div", { className: cx("".concat(prefixCls, "-right-icon-wrapper"), "".concat(prefixCls, "-icon-wrapper")) },
        React.createElement(IconMenuUnfold, { onClick: handleRightFold, className: "".concat(prefixCls, "-right-icon") }))) : (React.createElement("div", { className: cx("".concat(prefixCls, "-right-icon-wrapper"), "".concat(prefixCls, "-icon-wrapper")), style: { right: fixedIconOffsetRight } },
        React.createElement(IconMenuFold, { onClick: handleRightFold, className: "".concat(prefixCls, "-right-icon") })))));
    var TitleNode = (React.createElement(React.Fragment, null, title && rightUnFold && (React.createElement("div", { className: "".concat(prefixCls, "-header") },
        React.createElement("div", { className: "".concat(prefixCls, "-header-").concat(typeof title === 'string' ? 'title' : 'node') }, title)))));
    var FoldIcon = function () { return (React.createElement(React.Fragment, null,
        fold === 'right' && rightFoldIcon,
        fold === 'top' && topFoldIcon)); };
    var AnchorNode = isFolded ? null : (React.createElement(ArcoAnchor, __assign({ className: cx("".concat(prefixCls, "-list")), scrollContainer: propScrollContainer, hash: hash, affix: false }, rest, { ref: ref }, anchorProps),
        React.createElement(ErrorLinkListContext.Provider, { value: errorLinkList }, options ? handleOptionsToLink(options) : children)));
    var FooterNode = (React.createElement("p", { className: "".concat(prefixCls, "-footer-container") }, footer ? (React.createElement("div", { className: "".concat(prefixCls, "-footer") }, footer)) : initOptionsLength.current + linkLimitCount > optionsLength ? (React.createElement("div", { className: "".concat(prefixCls, "-add-btn"), onClick: onAddItem }, addBtnIcon !== null && addBtnIcon !== void 0 ? addBtnIcon : React.createElement(IconAdd, { height: "16", width: "16" }),
        React.createElement("div", { className: "".concat(prefixCls, "-add-btn-text") }, addBtnText))) : null));
    return (React.createElement(AffixWrapper, { affix: affix, target: getAffixTarget, offsetTop: offsetTop, offsetBottom: offsetBottom, affixStyle: affixStyle },
        React.createElement("div", { "data-tid": "m4b_anchor", className: cx(prefixCls, !rightUnFold ? "".concat(prefixCls, "-right-folded") : undefined, !topUnFold ? "".concat(prefixCls, "-top-folded") : undefined, className), style: style },
            React.createElement(FoldIcon, null),
            TitleNode,
            AnchorNode,
            (showAddBtn || footer) && FooterNode)));
};
var ForwardRefAnchor = forwardRef(Anchor);
ForwardRefAnchor.displayName = 'Anchor';
export default ForwardRefAnchor;
